import { useEffect, useState } from 'react';
import { useAuthStore } from '@/features/auth/store/auth-store';
import {
  fijarTechoParaEditarRoles,
  olvidarTechoParaEditarRoles,
  techoParaEditarRoles,
} from '@/features/auth/tenant-modules';
import { permissionService } from '../services/permission-service';

/**
 * El techo (lo contratado) de la EMPRESA cuyos roles se editan, para decidir qué grupos ofrecer (D4, 16-oct).
 *
 * Quien administra una empresa trae el techo en su sesión. El PLATFORM_ADMIN no (no se le aplica techo), así que se
 * le pide al servidor el de la empresa de su sesión. Hasta que llega, o si falla, vale el de la sesión: nunca se
 * muestra de más (un producto por contrato sin techo no se ofrece).
 */
export function useTechoParaEditarRoles(): string[] | null {
  const esPlataforma = useAuthStore((s) => s.user?.role === 'PLATFORM_ADMIN');
  // La empresa de la sesión: si el PLATFORM_ADMIN cambia de empresa con la pantalla montada, se pide el techo de nuevo (M1).
  const tenantId = useAuthStore((s) => s.user?.tenantId);
  const [techo, setTecho] = useState<string[] | null>(() => techoParaEditarRoles());

  useEffect(() => {
    if (!esPlataforma) {
      olvidarTechoParaEditarRoles();
      setTecho(techoParaEditarRoles());
      return;
    }
    // Otra empresa pudo haber quedado en memoria (soporte, cambio de portal): se pide de nuevo.
    olvidarTechoParaEditarRoles();
    setTecho(techoParaEditarRoles());
    let vigente = true;
    permissionService
      .getCompanyModules()
      .then((r) => {
        // Una respuesta vieja (de la empresa anterior) no pisa el almacén compartido (M10).
        if (!vigente) return;
        fijarTechoParaEditarRoles(r?.tenantModules);
        setTecho(techoParaEditarRoles());
      })
      .catch(() => {
        /* sin respuesta: queda el techo de la sesión */
      });
    return () => {
      vigente = false;
    };
  }, [esPlataforma, tenantId]);

  return techo;
}
